import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ErrorMessage } from '../components';
import { ErrorCode } from './CustomErrorBoundary';
const ErrorComponent = ({ errorCode, withCloseButton }) => {
    let messageRef;
    switch (errorCode) {
        case ErrorCode.NOTFOUND:
            messageRef = 'ERROR_MSG_NOT_FOUND';
            break;
        case ErrorCode.TIMEOUT:
            messageRef = 'ERROR_MSG_TIME_OUT';
            break;
        case ErrorCode.SERVERSIDE:
            messageRef = 'ERROR_MSG_SERVER';
            break;
        case ErrorCode.ERROR:
        default:
            messageRef = 'SOMETHING_WENT_WRONG';
            break;
    }
    return _jsx(ErrorMessage, { messageRef: messageRef, withCloseButton: withCloseButton });
};
export default ErrorComponent;
